export const MODAL_CONTEXT = {
  RESUME_VIA_BANNER: 'resume_via_banner',
  PREFILLED_BASE_PACKAGE: 'prefilled_base_package',
  FROM_SCRATCH: 'from_scratch',
  FLOW_SWITCH: 'flow_switch',
};

export function determineModalContext({
  hasCartItemKey,
  hasSessionConfig,
  hasDraft,
  hasUrlPakket,
  hasBasePackage,
  savedType,
  savedQuantity,
  hasFlowSwitch,
}) {
  if (hasFlowSwitch) {
    return {
      context: MODAL_CONTEXT.FLOW_SWITCH,
      showModal: true,
    };
  }

  if (hasDraft || hasCartItemKey || hasSessionConfig) {
    return {
      context: MODAL_CONTEXT.RESUME_VIA_BANNER,
      showModal: false,
    };
  }

  if (hasUrlPakket || hasBasePackage) {
    return {
      context: MODAL_CONTEXT.PREFILLED_BASE_PACKAGE,
      showModal: false,
      needsTypeQuantityInit: !savedType || !savedQuantity,
    };
  }

  return {
    context: MODAL_CONTEXT.FROM_SCRATCH,
    showModal: true,
  };
}

export function getContextOptions(configData) {
  return {
    hasCartItemKey: sessionStorage.getItem('s7_cart_item_key') !== null,
    hasSessionConfig: sessionStorage.getItem('s7_current_config') !== null,
    hasDraft: localStorage.getItem('s7_configuration_draft') !== null,
    hasUrlPakket: new URLSearchParams(window.location.search).has('pakket'),
    hasBasePackage: configData?.basePackage?.id !== undefined,
    savedType: sessionStorage.getItem('s7_package_type'),
    savedQuantity: sessionStorage.getItem('s7_package_quantity'),
    hasFlowSwitch: sessionStorage.getItem('s7_flow_switch') === 'true',
  };
}

export function initializePrefilledPackageTypeQuantity() {
  const savedType = sessionStorage.getItem('s7_package_type');
  const savedQuantity = sessionStorage.getItem('s7_package_quantity');

  const packageType = savedType || 'large';
  const quantity = savedQuantity ? parseInt(savedQuantity) : 10;

  if (!savedType) sessionStorage.setItem('s7_package_type', packageType);
  if (!savedQuantity)
    sessionStorage.setItem('s7_package_quantity', String(quantity));

  return { packageType, quantity };
}

export function markFlowSwitch() {
  sessionStorage.setItem('s7_flow_switch', 'true');
}

export function clearFlowSwitch() {
  sessionStorage.removeItem('s7_flow_switch');
}
